exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._25Ma-7waZRB5b3{background-color:#fafbfc;display:flex;z-index:-900;height:100%;width:100%;position:fixed;top:0;left:0;overflow:hidden}._1iBKgg4Sp7oTHh,._2heo-sf3Q6RhF0{position:absolute;width:400px;bottom:0;z-index:-999;max-width:30%}@media only screen and (max-width:750px){._1iBKgg4Sp7oTHh,._2heo-sf3Q6RhF0{display:none}}._1iBKgg4Sp7oTHh{left:0}._2heo-sf3Q6RhF0{right:0}", ""]);

// exports
exports.locals = {
	"background": "_25Ma-7waZRB5b3",
	"left": "_1iBKgg4Sp7oTHh",
	"right": "_2heo-sf3Q6RhF0"
};